import React from 'react'
import { useRecoilValue, useResetRecoilState } from 'recoil'
import { modalSendingState } from 'Pages/MessageCheckupSummary/recoil/state/modals'

import ModalMessageBeingSent from 'Components/ModalMessageBeingSent'

const ModalBeingSent = () => {
  const { show } = useRecoilValue(modalSendingState)
  const handleClose = useResetRecoilState(modalSendingState)

  return <ModalMessageBeingSent show={show} onClose={handleClose} />
}

export default ModalBeingSent
